import styled from 'styled-components';

import { colors } from 'constants/colors';

import { GetMicrostoreProductsQuery, HotDrinksInstructionFragmentFragment } from 'data/__generated__';

export const HotDrinksProductsSection = ({
    instruction,
    products,
    selectedLocationId,
    setSelectedLocationId,
}: {
    instruction: HotDrinksInstructionFragmentFragment;
    products: GetMicrostoreProductsQuery['getMicrostoreProducts'];
    selectedLocationId?: string | null;
    setSelectedLocationId?: (selectedLocationId: string | null) => void;
}) => {
    if (instruction.locations.length === 0) {
        return null;
    }

    const productById = new Map(products.map((p) => [p._id, p]));

    return (
        <>
            {instruction.locations.map((location) => {
                const product = productById.get(location.productId);
                const isSelected = location.microstoreLocationId === selectedLocationId;
                return (
                    <ProductContainer key={location.microstoreLocationId}>
                        <ProductName
                            onClick={() => {
                                setSelectedLocationId?.(location.microstoreLocationId);
                            }}
                            $isSelected={isSelected}
                        >
                            {product?.name ?? location.productId}
                        </ProductName>
                        <LevelContainer>
                            {location.initialTrayLevel}g → {location.targetTrayLevel}g
                        </LevelContainer>
                    </ProductContainer>
                );
            })}
        </>
    );
};

const ProductContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const ProductName = styled.div<{ $isSelected: boolean }>`
    cursor: pointer;
    font-weight: bold;
    width: 50%;
    color: ${({ $isSelected }) => ($isSelected ? colors.greenDarker : colors.pureBlack)};
`;

const LevelContainer = styled.div`
    margin-left: 10px;
    width: 50%;
`;
